module.exports = __webpack_public_path__ + "static/img/logo.3d19bcb0.png";